import type { WorkItemStatus, ProjectStatus } from '../types/models.js';

export const WORK_ITEM_STATUSES: Record<WorkItemStatus, {
  label: string;
  description: string;
  color: string;
  bgColor: string;
  icon: string;
}> = {
  draft: {
    label: 'Draft',
    description: 'Not yet shared with client',
    color: '#6b7280',
    bgColor: 'rgba(107, 114, 128, 0.1)',
    icon: 'file-edit',
  },
  seeking_commentary: {
    label: 'Seeking Commentary',
    description: 'Awaiting client feedback',
    color: '#f59e0b',
    bgColor: 'rgba(245, 158, 11, 0.1)',
    icon: 'message-circle',
  },
  approval_requested: {
    label: 'Approval Requested',
    description: 'Ready for client approval',
    color: '#8b5cf6',
    bgColor: 'rgba(139, 92, 246, 0.1)',
    icon: 'check-circle',
  },
  changes_requested: {
    label: 'Changes Requested',
    description: 'Client requested modifications',
    color: '#ef4444',
    bgColor: 'rgba(239, 68, 68, 0.1)',
    icon: 'alert-circle',
  },
  approved: {
    label: 'Approved',
    description: 'Client has approved this item',
    color: '#10b981',
    bgColor: 'rgba(16, 185, 129, 0.1)',
    icon: 'check-check',
  },
  archived: {
    label: 'Archived',
    description: 'No longer active',
    color: '#9ca3af',
    bgColor: 'rgba(156, 163, 175, 0.1)',
    icon: 'archive',
  },
};

export const PROJECT_STATUSES: Record<ProjectStatus, {
  label: string;
  color: string;
}> = {
  active: {
    label: 'Active',
    color: '#10b981',
  },
  completed: {
    label: 'Completed',
    color: '#6366f1',
  },
  archived: {
    label: 'Archived',
    color: '#9ca3af',
  },
};

export const STATUS_FLOW: Record<WorkItemStatus, WorkItemStatus[]> = {
  draft: ['seeking_commentary', 'approval_requested', 'archived'],
  seeking_commentary: ['draft', 'approval_requested', 'archived'],
  approval_requested: ['draft', 'seeking_commentary', 'approved', 'changes_requested'],
  changes_requested: ['draft', 'seeking_commentary', 'approval_requested', 'archived'],
  approved: ['archived'],
  archived: ['draft'],
};
